// The phone seam (calls round, step 2). Flowology has no browser phone today: a call rings people's own
// phones (services/api/src/voice-routes.ts, <Dial><Number>), so nothing in the office app can answer,
// hold, transfer or end it, and nobody's "taking calls" state exists. The pages follow the call instead:
// the strip shows it ringing, then answered on a phone, and its page opens beside it. This is the one
// switch a browser phone turns on: with `controls`, the strip draws Answer, Answer and hold and Send to
// voicemail on a ringing call, Hold, Transfer… and End call on your own, and CallStatus at its end.

/** What the phone can do from the office app. */
export interface PhoneCapability {
  /** The call controls and the taking-calls status are drawn (a browser phone is on). */
  controls: boolean;
  /** Does it: a browser phone's answer, hold, transfer, end or voicemail. */
  act?: (what: PhoneAct, callId: string) => void;
}

export type PhoneAct = 'answer' | 'answer-hold' | 'voicemail' | 'hold' | 'transfer' | 'end';

/** Today: calls ring people's phones, and the app follows them. */
export const PHONE: PhoneCapability = { controls: false };

/** The phone this office app has (one place to read it, so a browser phone switches it here). */
export const usePhone = (): PhoneCapability => PHONE;
